import { render, staticRenderFns } from "./DatInfo.vue?vue&type=template&id=08ca5e0e&scoped=true&"
import script from "./DatInfo.vue?vue&type=script&lang=js&"
export * from "./DatInfo.vue?vue&type=script&lang=js&"
import style0 from "./DatInfo.vue?vue&type=style&index=0&id=08ca5e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ca5e0e",
  null
  
)

export default component.exports